function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import CurrentSubscription from "@common/components/order/subscriptions/CurrentSubscription";
import OrderSummary from "@common/components/order/subscriptions/OrderSummary";
import PaymentMethod from "@common/components/payment/PaymentMethod";
import { formatPrice } from "@common/services/helpers";
import request from "@common/services/request";
import PrismicClient from "@common/utils/prismic";
import { TOOLTIP_SHOW_DELAY } from "@config/constants";
import { CHARGE_TYPE_RECURRING, SUBSCRIPTION_PLAN_BASIC_ID } from "@config/constants";
import { isEmpty, set } from "lodash";
import { stripCurrencyConversion } from "@common/services/helpers";
var DetailsItem = function(props) {
    var title = props.title, children = props.children;
    return /*#__PURE__*/ _jsxs("div", {
        className: "details-item",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "details-title",
                children: title
            }),
            children
        ]
    });
};
var CreditsRow = function(props) {
    var _userDetails_billingAddress;
    var title = props.title, amount = props.amount, currencyCode = props.currencyCode, toolTipMessage = props.toolTipMessage, userDetails = props.userDetails, currencyConversion = props.currencyConversion;
    var _userDetails_billingAddress_country;
    var country = (_userDetails_billingAddress_country = userDetails === null || userDetails === void 0 ? void 0 : (_userDetails_billingAddress = userDetails.billingAddress) === null || _userDetails_billingAddress === void 0 ? void 0 : _userDetails_billingAddress.country) !== null && _userDetails_billingAddress_country !== void 0 ? _userDetails_billingAddress_country : userDetails === null || userDetails === void 0 ? void 0 : userDetails.predifinedCountryCode;
    var showEuro = country === 'BG' || country === 'Bulgaria';
    return /*#__PURE__*/ _jsxs("p", {
        className: "clearfix",
        children: [
            /*#__PURE__*/ _jsxs("span", {
                className: "float-left",
                children: [
                    /*#__PURE__*/ _jsxs("span", {
                        "data-for": "payment-tooltip",
                        "data-tip": toolTipMessage,
                        className: "icon icon-info",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "path1"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "path2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("span", {
                        className: "credits-title",
                        children: [
                            title,
                            ":"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("span", {
                className: "float-right credits-amount",
                children: [
                    formatPrice(amount, "EUR", currencyConversion),
                    showEuro && /*#__PURE__*/ _jsxs("span", {
                        className: "euro",
                        children: [
                            " / ",
                            formatPrice(amount, "EUR", {
                                conversion_rate: currencyConversion.conversion_rate,
                                currency: "EUR"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var generateOrderSummary = function(subscription) {
    var _subscription_plan, _subscription_addons;
    return {
        subscription: subscription === null || subscription === void 0 ? void 0 : (_subscription_plan = subscription.plan) === null || _subscription_plan === void 0 ? void 0 : _subscription_plan[0],
        r_addons: subscription === null || subscription === void 0 ? void 0 : (_subscription_addons = subscription.addons) === null || _subscription_addons === void 0 ? void 0 : _subscription_addons.filter(function(param) {
            var chargeType = param.chargeType;
            return chargeType === CHARGE_TYPE_RECURRING;
        })
    };
};
export var Payment = function(props) {
    var _prismic_subscriptionsAll, _userDetails_subscription, _subscription_plan, _userDetails_subscription_, _userDetails_subscription1;
    var i18n = props.i18n, userDetails = props.userDetails, screenType = props.screenType, prismic = props.prismic;
    var _useState = _sliced_to_array(useState(false), 2), estimateLoading = _useState[0], setEstimateLoading = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), nextInvoiceEstimate = _useState1[0], setNextInvoiceEstimate = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), showWarningBanner = _useState2[0], setShowWarningBanner = _useState2[1];
    var _ref;
    var subscriptionsPrismic = (_ref = !isEmpty(prismic === null || prismic === void 0 ? void 0 : prismic.subscriptionsAll) && (prismic === null || prismic === void 0 ? void 0 : (_prismic_subscriptionsAll = prismic.subscriptionsAll) === null || _prismic_subscriptionsAll === void 0 ? void 0 : _prismic_subscriptionsAll.find(function(item) {
        var _userDetails_billingAddress;
        return item.country_code === ((_userDetails_billingAddress = userDetails.billingAddress) === null || _userDetails_billingAddress === void 0 ? void 0 : _userDetails_billingAddress.country);
    }))) !== null && _ref !== void 0 ? _ref : prismic === null || prismic === void 0 ? void 0 : prismic.subscriptions;
    var subscription = userDetails === null || userDetails === void 0 ? void 0 : (_userDetails_subscription = userDetails.subscription) === null || _userDetails_subscription === void 0 ? void 0 : _userDetails_subscription[0];
    var currencyConversion = stripCurrencyConversion(subscriptionsPrismic);
    var plan = subscription === null || subscription === void 0 ? void 0 : (_subscription_plan = subscription.plan) === null || _subscription_plan === void 0 ? void 0 : _subscription_plan[0];
    useEffect(function() {
        if (isEmpty(userDetails.paymentMethod) && (subscription === null || subscription === void 0 ? void 0 : subscription.planId) !== SUBSCRIPTION_PLAN_BASIC_ID) {
            setShowWarningBanner(true);
        } else {
            setShowWarningBanner(false);
        }
    }, [
        userDetails,
        subscription === null || subscription === void 0 ? void 0 : subscription.planId
    ]);
    useEffect(function() {
        _async_to_generator(function() {
            var _estimateResponse_data, estimateResponse;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setEstimateLoading(true);
                        return [
                            4,
                            request({
                                method: "POST",
                                url: "users/me/futureEstimate"
                            }).catch(function() {
                                setEstimateLoading(false);
                            })
                        ];
                    case 1:
                        estimateResponse = _state.sent();
                        setEstimateLoading(false);
                        setNextInvoiceEstimate(estimateResponse === null || estimateResponse === void 0 ? void 0 : (_estimateResponse_data = estimateResponse.data) === null || _estimateResponse_data === void 0 ? void 0 : _estimateResponse_data.futureInvoiceEstimate);
                        return [
                            2
                        ];
                }
            });
        })();
    }, []);
    var hasAddons = !isEmpty(userDetails === null || userDetails === void 0 ? void 0 : (_userDetails_subscription_ = userDetails.subscription[0]) === null || _userDetails_subscription_ === void 0 ? void 0 : _userDetails_subscription_.addons);
    var renderAddons = function() {
        var _userDetails_subscription_;
        var addons = (userDetails === null || userDetails === void 0 ? void 0 : (_userDetails_subscription_ = userDetails.subscription[0]) === null || _userDetails_subscription_ === void 0 ? void 0 : _userDetails_subscription_.addons) || [];
        return /*#__PURE__*/ _jsx("div", {
            className: "order-current-subscription",
            children: /*#__PURE__*/ _jsx("div", {
                className: "column gap-8",
                children: addons.map(function(addon) {
                    var _subscriptionsPrismic_r_addons_items, _addonPrismic_title, _addonPrismic_subtitle;
                    var addonPrismic = subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_r_addons_items = subscriptionsPrismic.r_addons_items) === null || _subscriptionsPrismic_r_addons_items === void 0 ? void 0 : _subscriptionsPrismic_r_addons_items.find(function(param) {
                        var id = param.id;
                        return id === addon.id;
                    });
                    return /*#__PURE__*/ _jsxs("div", {
                        className: "column",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "title",
                                children: addonPrismic === null || addonPrismic === void 0 ? void 0 : (_addonPrismic_title = addonPrismic.title) === null || _addonPrismic_title === void 0 ? void 0 : _addonPrismic_title.text
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "subtitle",
                                children: addonPrismic === null || addonPrismic === void 0 ? void 0 : (_addonPrismic_subtitle = addonPrismic.subtitle) === null || _addonPrismic_subtitle === void 0 ? void 0 : _addonPrismic_subtitle.text
                            })
                        ]
                    }, addon.id);
                })
            })
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ReactTooltip, {
                id: "payment-tooltip",
                className: "tooltip",
                delayShow: TOOLTIP_SHOW_DELAY,
                place: "bottom",
                disable: !screenType.web,
                effect: "solid"
            }),
            showWarningBanner && /*#__PURE__*/ _jsxs("div", {
                className: "warning-banner-wrapper",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "warning-text",
                        // biome-ignore lint/security/noDangerouslySetInnerHtml: ig necessary
                        dangerouslySetInnerHTML: {
                            __html: (userDetails === null || userDetails === void 0 ? void 0 : userDetails.cf_bank_payment) ? i18n.account.subscriptionExpirationWarningAutoCollection : i18n.account.subscriptionExpirationWarning
                        }
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "icon icon-clear pointer close-button",
                        onClick: function() {
                            return setShowWarningBanner(false);
                        },
                        onKeyDown: function() {
                            return setShowWarningBanner(false);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "payment-wrapper",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "column details-wrapper",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "column subscription-details-wrapper",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "section-title",
                                        children: i18n.account.paymentDetails
                                    }),
                                    /*#__PURE__*/ _jsx(DetailsItem, {
                                        title: i18n.account.currentSubscription,
                                        children: /*#__PURE__*/ _jsx(CurrentSubscription, {
                                            subscriptionsPrismicAll: isEmpty(subscriptionsPrismic) ? [] : [
                                                subscriptionsPrismic
                                            ],
                                            hideCurrentPlanBadge: true
                                        })
                                    }),
                                    hasAddons && /*#__PURE__*/ _jsx(DetailsItem, {
                                        title: i18n.account.addons,
                                        children: renderAddons()
                                    }),
                                    /*#__PURE__*/ _jsxs(DetailsItem, {
                                        title: i18n.account.availableCredits,
                                        children: [
                                            /*#__PURE__*/ _jsx(CreditsRow, {
                                                userDetails: userDetails,
                                                currencyConversion: currencyConversion,
                                                title: i18n.account.refundableCredits,
                                                amount: userDetails.refundableCredits,
                                                currencyCode: plan.currencyCode,
                                                toolTipMessage: i18n.account.paymentInfoTooltip1
                                            }),
                                            /*#__PURE__*/ _jsx(CreditsRow, {
                                                userDetails: userDetails,
                                                currencyConversion: currencyConversion,
                                                title: i18n.account.promotionalCredits,
                                                amount: userDetails.promotionalCredits,
                                                currencyCode: plan.currencyCode,
                                                toolTipMessage: i18n.account.paymentInfoTooltip2
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "column payment-method-wrapper",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "section-title",
                                        children: i18n.account.paymentMethod
                                    }),
                                    /*#__PURE__*/ _jsx(PaymentMethod, {
                                        paymentMethod: userDetails.paymentMethod
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(OrderSummary, {
                        subscriptionsPrismic: subscriptionsPrismic,
                        orderSummary: generateOrderSummary(userDetails === null || userDetails === void 0 ? void 0 : (_userDetails_subscription1 = userDetails.subscription) === null || _userDetails_subscription1 === void 0 ? void 0 : _userDetails_subscription1[0]),
                        customTitle: i18n.account.nextBillingPeriod,
                        invoiceEstimate: nextInvoiceEstimate,
                        loading: estimateLoading,
                        billingAddress: userDetails.billingAddress,
                        disablePayment: true,
                        disableFooterInfo: true,
                        disableAddress: true,
                        additionalClasses: "".concat(showWarningBanner ? "banner" : "")
                    })
                ]
            })
        ]
    });
};
var mapStateToProps = function(param) {
    var i18n = param.i18n, userDetails = param.userDetails, screenType = param.screenType, prismic = param.prismic;
    return {
        i18n: i18n,
        userDetails: userDetails,
        screenType: screenType,
        prismic: prismic
    };
};
var mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(Payment);
